import { all, select, call, put } from 'redux-saga/effects';
import axios from 'axios';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { userSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/user';
import { getProfileOwner } from '../../selectors/users';
import { API_BASE_PATH } from '../../../constants';
import { PapiWatchersRequestParams } from '../../../types/papi';
import { setCsrfOnParams } from '.';

function* fetchFromApi(params) {
  params = yield call(setCsrfOnParams, params);
  return yield axios
    .get(`${API_BASE_PATH}/module/watchers`, { params })
    .catch(response => false);
}

export default function* fetchMoreWatchers(action) {
  const { streamId } = action;

  const [offset, limit, moduleId, profileOwner] = yield all([
    select(state => withOffset.selectors.getNextOffset(state, streamId)),
    select(state => streamSelectors.getItemsPerFetch(state, streamId)),
    select(state =>
      streamSelectors.getStreamParam(state, streamId, 'moduleId')
    ),
    select(getProfileOwner),
  ]);

  const queryParams: PapiWatchersRequestParams = {
    username: profileOwner.user.username,
    moduleid: moduleId,
    offset,
    limit,
  };

  const response = yield call(fetchFromApi, queryParams);

  if (response && response.status === 200) {
    const { hasMore, nextOffset, results } = response.data;
    const { result, entities } = normalize(results, [userSchema]);

    yield put(
      withOffset.actions.fetchSuccess({
        streamId,
        hasMore,
        nextOffset,
        items: result,
        entities,
      })
    );
  }

  // TODO error catching
}
